import CustomIcon from "../../../core/CustomIcon/CustomIcon";
import arrow from "../../../../assets/icons/arrow.svg";
import classnames from "classnames";
import { useState } from "react";
import classes from "../Banner.module.scss";
import { Link } from "react-router-dom";

const PlatformBanner = ({ image, title, url, description, className }) => {
  const [isHover, setIsHover] = useState(false);

  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };
  return (
    <div className={classnames(className, classes.platformcontainer)}>
      <CustomIcon
        src={image}
        iconHeight={30}
        iconWidth={30}
        style={{
          backgroundColor: "#FFFFFF",
          padding: 14,
          borderRadius: "100px",
        }}
      />
      <div className={classes.title}>{title}</div>
      <div className={classes.description}>{description}</div>
      <Link
        reloadDocument={true}
        to={url}
        rel="noopener noreferrer"
        style={{ marginTop: "auto" }}
      >
        <div
          style={{
            position: "relative",
            backgroundColor: isHover ? "#0F172A" : "#FFFFFF",
            borderRadius: "100px",
            height: 36,
            width: 36,
            border: "1px solid #0F172A",
            cursor: "pointer",
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <CustomIcon
            src={arrow}
            iconHeight={12}
            iconWidth={12}
            className={classnames("center")}
            style={{
              filter: isHover
                ? "invert(100%) sepia(0%) saturate(0%) hue-rotate(73deg) brightness(94%) contrast(105%)"
                : "unset",
            }}
          />
        </div>
      </Link>
    </div>
  );
};
export default PlatformBanner;
